import ApartmentEntry from "../components/ApartmentEntry.js"
import { BASE_ASSETS_URL } from "../utils/constants.js"
import SEO from "../components/SEO.js"
import { getApartmentSchema } from "../utils/structuredData.js"

const ApartmentsPage = ({ text }) => {
    const apartmentTexts = [{
        key: "apartmentDavid",
        apartmentName: text.apartmentsDavidTitle,
        apartmentDescription: text.apartmentsDavidBody,
        apartmentBedroom: text.apartmentsDavidBedroom,
        apartmentKitchen: text.apartmentsDavidKitchen,
        apartmentBathroom: text.apartmentsDavidBathroom,
        apartmentView: text.apartmentDavidView,
        apartmentPeople: text.apartmentsDavidPeople,
        apartmentEquipment: text.apartmentsDavidEquipment,
        apartmentAdditionalBed: text.apartmentsDavidAdditionalBed,
        apartmentImageSrc: [
            `${BASE_ASSETS_URL}images/appartment_david_1.jpg`,
            `${BASE_ASSETS_URL}images/appartment_david_2.jpg`,
            `${BASE_ASSETS_URL}images/appartment_david_3.jpg`,
        ],
    },
    {
        key: "apartmentJulian",
        apartmentName: text.apartmentsJulianTitle,
        apartmentDescription: text.apartmentsJulianBody,
        apartmentBedroom: text.apartmentsJulianBedroom,
        apartmentKitchen: text.apartmentsJulianKitchen,
        apartmentBathroom: text.apartmentsJulianBathroom,
        apartmentView: text.apartmentJulianView,
        apartmentPeople: text.apartmentsJulianPeople,
        apartmentEquipment: text.apartmentsJulianEquipment,
        apartmentAdditionalBed: text.apartmentsJulianAdditionalBed,
        apartmentImageSrc: [
            `${BASE_ASSETS_URL}images/appartment_julian_1.jpg`,
            `${BASE_ASSETS_URL}images/appartment_julian_2.jpg`,
            `${BASE_ASSETS_URL}images/appartment_julian_3.jpg`,
            //`${BASE_ASSETS_URL}images/appartment_julian_4.jpg`,  // Vertical image, does not fit
        ],
    },
    {
        key: "apartmentPhilipp",
        apartmentName: text.apartmentsPhilippTitle,
        apartmentDescription: text.apartmentsPhilippBody,
        apartmentBedroom: text.apartmentsPhilippBedroom,
        apartmentKitchen: text.apartmentsPhilippKitchen,
        apartmentBathroom: text.apartmentsPhilippBathroom,
        apartmentView: text.apartmentPhilippView,
        apartmentPeople: text.apartmentsPhilippPeople,
        apartmentEquipment: text.apartmentsPhilippEquipment,
        apartmentAdditionalBed: text.apartmentsPhilippAdditionalBed,
        apartmentImageSrc: [
            `${BASE_ASSETS_URL}images/appartment_philipp_1.jpg`,
            `${BASE_ASSETS_URL}images/appartment_philipp_2.jpg`,
            `${BASE_ASSETS_URL}images/appartment_philipp_3.jpg`,
        ],
    }
    ]

    // Create structured data for each apartment
    const apartmentStructuredData = apartmentTexts.map(apt =>
        getApartmentSchema({
            name: apt.apartmentName,
            description: apt.apartmentDescription,
            image: apt.apartmentImageSrc[0],
            numberOfRooms: apt.apartmentBedroom,
            floorSize: apt.apartmentEquipment,
            amenities: [
                apt.apartmentKitchen,
                apt.apartmentBathroom,
                apt.apartmentView,
                apt.apartmentAdditionalBed
            ].filter(Boolean),
            url: `https://www.drockerhof.it/apartments#${apt.key}`
        })
    );

    return (
        <>
            <SEO
                title={text.apartmentsTitle}
                description={text.apartmentsBody}
                structuredData={apartmentStructuredData}
                alternateUrls={[
                    { lang: 'de', url: 'https://www.drockerhof.it/de/apartments' },
                    { lang: 'it', url: 'https://www.drockerhof.it/it/apartments' },
                    { lang: 'en', url: 'https://www.drockerhof.it/en/apartments' }
                ]}
            />
            <div className="drocker-body">
                <div className="position-relative">
                    <div className="drocker-responsive-image" style={{ backgroundImage: `url(${BASE_ASSETS_URL}images/interior_staircase_3.jpg)` }}></div>
                    <div className="container drocker-h1-container">
                        <h1 className="text-white mb-0 drocker-title-outline">{text.apartmentsTitle}</h1>
                    </div>
                </div>
                <div className="container container-fluid">
                    <div className="pt-4">
                        <p dangerouslySetInnerHTML={{ __html: text.apartmentsBody }}></p>
                        {apartmentTexts.map((apartmentText) =>
                            (apartmentText.apartmentName !== undefined) && <ApartmentEntry key={apartmentText.key} apartmentText={apartmentText} />
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default ApartmentsPage
